export default __webpack_public_path__ + "static/media/iconfont.5af13919.woff";